import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, AlertController, ToastController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';
import { PNMaps } from '../../pan.maps';

/**
 * Generated class for the SetdrivershiftPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-setdrivershift',
  templateUrl: 'setdrivershift.html',
})
export class SetdrivershiftPage {
  shiftData = []
  hasStart = false;
  hasEnd = false;
  hasActivePause = '0';
  HasActivePauseType = '-1';
  HasActivePauseTypeColor = '';
  nowdate = '';
  // nowday = '';
  // nowtime = '';
  //nowmonth = '';
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  myLon: any
  myLat: any
  isMyPozOK = false

  setpauza1 = false
  setpauza2 = false
  setpauza3 = false

  loadingData = false


  constructor(public panMaps: PNMaps, public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public popoverCtrl: PopoverController, public alertCtrl: AlertController, public toastCtrl: ToastController) {
    this.panMaps.isPozWatching = false
    this.panMaps.isMyPozOK = false
  }

  ionViewDidLoad() {
    this.loadingData = true

    this.nowdate = moment().format("DD") + ' ' + this.dic.l[moment().format('MMMM')] + ', ' + this.dic.l[moment().format('dddd')]
    //this.nowmonth = this.dic.l[moment().format('MMMM')]
    //this.nowday = this.dic.l[moment().format('dddd')]
    //this.nowtime = moment().format(this.gn.user.TFormat)
    console.log('ionViewDidLoad SetdrivershiftPage');
    var _that = this
    this.panMaps.getDriverPosition(function (_lat, _lng, _isMyPozOK) {
      _that.myLat = _lat
      _that.myLon = _lng
      _that.isMyPozOK = _isMyPozOK
      _that.loadData();
    })
  }

  loadData() {
    var _that = this

    var dat = {
      uid: _that.gn.crypt(_that.gn.user.UserId)
    }
    var _that = _that
    _that.gn._Post('/api/gn/getstartshift', dat, function (_data) {
      _that.shiftData = _data.data
      _that.hasActivePause = _data.activepause
      _that.HasActivePauseType = _data.activepausetype
      if (_that.HasActivePauseType + '' == '1') {
        _that.HasActivePauseTypeColor = '#5c93c4'
      }
      if (_that.HasActivePauseType + '' == '2') {
        _that.HasActivePauseTypeColor = '#6b8e23'
      }
      if (_that.HasActivePauseType + '' == '3') {
        _that.HasActivePauseTypeColor = '#f68c3a'
      }
      for (var s = 0; s < _that.shiftData.length; s++) {

        var start1 = moment(_that.shiftData[s].sdate, "YYYY-MM-DD");
        var end1 = moment(moment().format("YYYY-MM-DD"), "YYYY-MM-DD");
        var diffdays = moment.duration(end1.diff(start1)).asDays();

        if (diffdays == 0)
          _that.shiftData[s].sdate = moment(_that.shiftData[s].sdate).format("HH:mm")
        else
          _that.shiftData[s].sdate = moment(_that.shiftData[s].sdate).format("DD") + ' ' + _that.dic.l[moment(_that.shiftData[s].sdate).format('MMMM')] + ' ' + moment(_that.shiftData[s].sdate).format("HH:mm")

        if (_that.shiftData[s].typeact == 0) {//ima vneseno pocetok na smena
          _that.hasStart = true;
          _that.shiftData[s].desc = _that.dic.l["startshift"];
          _that.shiftData[s].edate = ''
          _that.shiftData[s].color = '#54d469'
        }
        if (_that.shiftData[s].typeact == 1) {
          _that.shiftData[s].desc = _that.dic.l["Break"];
          if (_that.shiftData[s].edate != null) {
            _that.shiftData[s].edate = moment(_that.shiftData[s].edate).format("HH:mm")
          } else {
            _that.shiftData[s].edate = '...'
          }
          if (_that.shiftData[s].breaktype + '' == '1') {
            _that.shiftData[s].color = '#5c93c4'
            _that.shiftData[s].desc1 = _that.dic.l["dbreaktype1"];
          }
          if (_that.shiftData[s].breaktype + '' == '2') {
            _that.shiftData[s].color = '#6b8e23'
            _that.shiftData[s].desc1 = _that.dic.l["dbreaktype2"];
          }
          if (_that.shiftData[s].breaktype + '' == '3') {
            _that.shiftData[s].color = '#f68c3a'
            _that.shiftData[s].desc1 = _that.dic.l["dbreaktype3"];
          }
        }
        if (_that.shiftData[s].typeact == 2) {//ima vneseno kraj na smena
          _that.hasEnd = true;
          _that.shiftData[s].desc = _that.dic.l["endshift"];
          _that.shiftData[s].edate = ''
          _that.shiftData[s].color = '#f53d3d'
        }

      }
      _that.setpauza1 = false
      _that.setpauza2 = false
      _that.setpauza3 = false
      _that.loadingData = false
    })
  }


  setStartEnd(_se) {
    this.gn.tfBtn = true;
    var _that = this
    if (_se == 0) {
      const confirm = this.alertCtrl.create({
        title: this.dic.l['startshift'] + '?',
        message: this.dic.l['doyouagreestartshift'] + '?',
        buttons: [
          {
            text: this.dic.l['cancel'],
            handler: () => {
              console.log('Disagree clicked');
              // this.gn.tfBtn = false;
              return
            }
          },
          {
            text: this.dic.l['ok'],
            handler: () => {
              console.log('Agree clicked');
              if (this.isMyPozOK) {
                var dat = {
                  did: this.gn.crypt(this.gn.user.driverid),
                  uid: this.gn.crypt(this.gn.user.UserId),
                  typeact: this.gn.crypt(_se), //0=pocetok na smena; 1=pauza; 2=kraj na smena
                  se: this.gn.crypt(-1),
                  lng: this.gn.crypt(this.myLon),
                  lat: this.gn.crypt(this.myLat),
                  type: this.gn.crypt(-1)
                }
                this.gn._Post('/api/gn/setstartshift', dat, function (_data) {
                  _that.loadData();
                  //_that.navCtrl.pop()
                  // _that.gn.tfBtn = false;
                })
              } else {
                const toast = _that.toastCtrl.create({
                  message: _that.dic.l['locationserviceerror'],
                  duration: 3000,
                  position: 'top'
                });
                toast.present();
              }
            }
          }
        ]
      });
      this.gn.tfBtn = false;
      confirm.present();
    }


    if (_se == 2) {
      const confirm = this.alertCtrl.create({
        title: this.dic.l['endshift'] + '?',
        message: this.dic.l['doyouagreeendshift'] + '?',
        buttons: [
          {
            text: this.dic.l['cancel'],
            handler: () => {
              console.log('Disagree clicked');
              // this.gn.tfBtn = false;
              return
            }
          },
          {
            text: this.dic.l['ok'],
            handler: () => {
              console.log('Agree clicked');
              if (this.isMyPozOK) {
                var dat = {
                  did: this.gn.crypt(this.gn.user.driverid),
                  uid: this.gn.crypt(this.gn.user.UserId),
                  typeact: this.gn.crypt(_se), //0=pocetok na smena; 1=pauza; 2=kraj na smena
                  se: this.gn.crypt(-1),
                  lng: this.gn.crypt(this.myLon),
                  lat: this.gn.crypt(this.myLat),
                  type: this.gn.crypt(-1)
                }
                this.gn._Post('/api/gn/setstartshift', dat, function (_data) {
                  _that.loadData();
                  //_that.navCtrl.pop()
                  // _that.gn.tfBtn = false;
                })
              } else {
                const toast = _that.toastCtrl.create({
                  message: _that.dic.l['locationserviceerror'],
                  duration: 3000,
                  position: 'top'
                });
                toast.present();
              }
            }
          }
        ]
      });
      this.gn.tfBtn = false;
      confirm.present();
    }


  }
  setPause(_se, _type) {
    this.setpauza1 = true
    this.setpauza2 = true
    this.setpauza3 = true
    this.gn.tfBtn = true;
    console.log('count++')

    //debugger
    var _that = this
    if (this.isMyPozOK) {
      var dat = {
        did: this.gn.crypt(this.gn.user.driverid),
        uid: this.gn.crypt(this.gn.user.UserId),
        typeact: this.gn.crypt(1), //0=pocetok na smena; 1=pauza; 2=kraj na smena,
        se: this.gn.crypt(_se), //1=poceotk na pauza; 0=kraj na pauza
        lng: this.gn.crypt(this.myLon),
        lat: this.gn.crypt(this.myLat),
        type: this.gn.crypt(_type)
      }
      this.gn._Post('/api/gn/setstartshift', dat, function (_data) {
        _that.loadData();
        //_that.navCtrl.pop()
        _that.gn.tfBtn = false;

      })
    } else {
      const toast = _that.toastCtrl.create({
        message: _that.dic.l['locationserviceerror'],
        duration: 3000,
        position: 'top'
      });
      _that.setpauza1 = false
      _that.setpauza2 = false
      _that.setpauza3 = false
      toast.present();
    }

  }
  copyCoords(_lat, _lng) {
    //debugger
    var inp = document.createElement('input');
    document.body.appendChild(inp)
    inp.value = _lat + ', ' + _lng

    inp.select();
    document.execCommand('copy', false);
    inp.remove();

    let toast = this.toastCtrl.create({
      message: this.dic.l["coordcopied"],
      duration: 3000,
      position: 'top'
    });
    toast.present();

  }
}



// WEBPACK FOOTER //
// ./src/pages/setdrivershift/setdrivershift.ts